module.exports = __webpack_public_path__ + "img/3.2ef32d76.jpg";